// src/components/ProjectCard.js
import React, { useState } from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const ImageContainer = styled.div`
  position: relative;
  height: 500px;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.3s ease-in-out;
`;

const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 1;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }

  ${props => props.direction === 'left' ? 'left: 10px;' : 'right: 10px;'}
`;

const Content = styled.div`
  padding: 20px;
`;

const Title = styled.h3`
  color: #0C2340;
  margin-bottom: 10px;
`;

const Description = styled.p`
  color: #333;
`;

const ProjectCard = ({ project }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageError, setImageError] = useState(false);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === project.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? project.images.length - 1 : prevIndex - 1
    );
  };

  const handleImageError = () => {
    console.error(`Failed to load image: ${project.images[currentImageIndex]}`);
    setImageError(true);
  };

  return (
    <Card>
      <ImageContainer>
      {imageError ? (
          <div>Error loading image</div>
        ) : (
          <Image 
            src={project.images[currentImageIndex]} 
            alt={project.title} 
            onError={handleImageError}
          />
        )}
        <ArrowButton direction="left" onClick={prevImage}>&lt;</ArrowButton>
        <ArrowButton direction="right" onClick={nextImage}>&gt;</ArrowButton>
      </ImageContainer>
      <Content>
        <Title>{project.title}</Title>
        <Description>{project.description}</Description>
      </Content>
    </Card>
  );
};

export default ProjectCard;